<template>
  <v-container fluid class="pa-1">
    <v-row no-gutters class="actual-state">
      <v-col class="text-xs-left pa-1" cols="12">{{ title }}</v-col>
      <v-col cols="12">
        <v-container fluid class="pa-0">
          <v-row no-gutters class="justify-space-between">
            <v-col
              class="pa-1"
              cols="3"
              v-for="(n, index) in totalImages"
              :key="index"
            >
              <v-card text tile class="actual-state__single-image" white>
                <v-container fluid fill-height class="pa-0">
                  <v-row
                    no-gutters
                    column
                    class="text-center justify-space-between fill-height"
                  >
                    <template
                      v-if="itemsSavedActualState[getSavedImageId(index)]"
                      class="text-center"
                    >
                      <v-icon
                        v-if="!queryParams"
                        class="actual-state__icon-delete"
                        color="accent"
                        dense
                        size="16"
                        @click.prevent="deleteAndCleanImage(getImageId(index))"
                        >fas fa-plus</v-icon
                      >
                      <img
                        :src="thumbnailSavedImage(getSavedImageId(index))"
                        class="actual-state__image"
                        alt="Image to upload"
                        @click="downloadImage(index)"
                      />
                      <v-col
                        tag="div"
                        block
                        class="text-center actual-state__image-text pa-0"
                        cols="12"
                        >{{ imagesTitles[index] }}</v-col
                      >
                    </template>
                    <template
                      v-else-if="itemsActualState[getImageId(index)]"
                      class="text-center"
                    >
                      <v-icon
                        v-if="!queryParams"
                        class="actual-state__icon-delete"
                        color="accent"
                        dense
                        size="16"
                        @click.prevent="deleteAndCleanImage(getImageId(index))"
                        >fas fa-plus</v-icon
                      >
                      <img
                        :src="thumbnailImage(getImageId(index))"
                        class="actual-state__image"
                        alt="Image to upload"
                      />
                      <v-col
                        tag="div"
                        block
                        class="text-center actual-state__image-text pa-0"
                        cols="12"
                        >{{ imagesTitles[index] }}</v-col
                      >
                    </template>
                    <template v-else>
                      <v-icon
                        class="actual-state__icon"
                        color="gray"
                        @click.prevent="uploadImage(getImageId(index))"
                        @onUpload="startImageResize"
                        @onComplete="endImageResize"
                        >fas fa-plus</v-icon
                      >
                      <template slot="loading">
                        <v-progress-circular
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </template>
                      <v-col
                        tag="div"
                        block
                        class="text-center actual-state__image-text pa-0"
                        cols="12"
                      >
                        {{ imagesTitles[index] }}
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row no-gutters class="actual-state">
      <v-col class="text-xs-left pa-1" cols="12"
        >Foto de checklist Físico</v-col
      >
      <v-col cols="12">
        <v-container fluid class="pa-0">
          <v-row no-gutters class="justify-space-between">
            <v-col class="pa-1" cols="4">
              <v-card text tile class="actual-state__single-image" white>
                <v-container fluid fill-height class="pa-0">
                  <v-row
                    no-gutters
                    column
                    class="text-center justify-space-between fill-height"
                  >
                    <template
                      v-if="itemsSavedActualState[getSavedImageId(8)]"
                      class="text-center"
                    >
                      <v-icon
                        v-if="!queryParams"
                        class="actual-state__icon-delete"
                        color="accent"
                        dense
                        size="16"
                        @click.prevent="deleteAndCleanImage(getImageId(8))"
                        >fas fa-plus</v-icon
                      >
                      <img
                        :src="thumbnailSavedImage(getSavedImageId(8))"
                        class="actual-state__image"
                        alt="Image to upload"
                        @click="downloadImage(8)"
                      />
                      <v-col
                        tag="div"
                        block
                        class="text-center actual-state__image-text pa-0"
                        cols="12"
                        >{{ imagesTitles[8] }}</v-col
                      >
                    </template>
                    <template
                      v-else-if="itemsActualState[getImageId(8)]"
                      class="text-center"
                    >
                      <v-icon
                        v-if="!queryParams"
                        class="actual-state__icon-delete"
                        color="accent"
                        dense
                        size="16"
                        @click.prevent="deleteAndCleanImage(getImageId(8))"
                        >fas fa-plus</v-icon
                      >
                      <img
                        :src="thumbnailImage(getImageId(8))"
                        class="actual-state__image"
                        alt="Image to upload"
                      />
                      <v-col
                        tag="div"
                        block
                        class="text-center actual-state__image-text pa-0"
                        cols="12"
                        >{{ imagesTitles[8] }}</v-col
                      >
                    </template>
                    <template v-else>
                      <v-icon
                        class="actual-state__icon"
                        color="gray"
                        @click.prevent="uploadImage(getImageId(8))"
                        @onUpload="startImageResize"
                        @onComplete="endImageResize"
                        >fas fa-plus</v-icon
                      >
                      <template slot="loading">
                        <v-progress-circular
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </template>
                      <v-col
                        tag="div"
                        block
                        class="text-center actual-state__image-text pa-0"
                        cols="12"
                      >
                        {{ imagesTitles[8] }}
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <input
      :disabled="accessToEdit"
      v-show="false"
      ref="uploadState"
      :type="'file'"
      accept="image/jpeg,image/png"
      @change="resizeFileImage($refs.uploadState.files)"
    />
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { errorMessage } from "@/services/MessageService";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { imagesMap } from "@/models/damage/ActualStateImages";
import { ResizeImage } from "@/services/ResizeImage";
export default {
  data() {
    return {
      title: "Fotos del estado actual del equipo",
      totalImages: 8,
      clickedID: "",
      images_titles: [
        "Frente",
        "Posterior",
        "Lateral 1",
        "Lateral 2",
        "Llanta FD",
        "Llanta FI",
        "Lanta PD",
        "Llanta PI"
      ]
    };
  },
  mounted() {
    if (this.queryParams) {
      const elementImgText = document.querySelectorAll(
        ".actual-state__image-text"
      );
      elementImgText.forEach(element => {
        element.setAttribute("style", "background-color: #009D4F;");
      });
      try {
        this.getChecklistDataTransfer({
          id: this.$route.params.id,
          checklistType: this.$props.event,
          actualState: true
        });
      } catch (error) {
        errorMessage(
          "Ha ocurrido un error inesperado al conseguir la información del checklist"
        );
      }
    }
  },
  props: ["path", "event", "accessToEdit", "queryPath", "queryParams"],
  computed: {
    ...mapState("checklistImages", ["itemsActualState"]),
    ...mapState("checklist", ["itemsSavedActualState"]),
    imagesTitles() {
      return Object.keys(imagesMap);
    }
  },
  methods: {
    ...mapActions("checklistImages", ["addImage", "deleteImage"]),
    ...mapActions("checklist", ["getChecklistDataTransfer"]),
    uploadImage(id) {
      this.clickedID = id;
      this.$refs.uploadState.click();
    },
    async resizeFileImage(refImage) {
      if (refImage) {
        const config = {
          file: refImage[0],
          maxSize: 1080
        };
        const resizedImage = await ResizeImage(config);
        var imageObject = { id: this.clickedID, thumbnail: resizedImage };
        this.addImage(imageObject);
      }
    },
    deleteAndCleanImage(id) {
      this.deleteImage(id);
      this.$refs;
    },
    getImageId(index) {
      return this.path + "-" + imagesMap[this.imagesTitles[index]];
    },
    getSavedImageId(index) {
      return this.queryPath + "-" + imagesMap[this.imagesTitles[index]];
    },
    thumbnailImage(path) {
      return this.itemsActualState[path].thumbnail;
    },
    thumbnailSavedImage(path) {
      return this.itemsSavedActualState[path].thumb;
    },
    getFullImage(path) {
      return this.itemsSavedActualState[path].thumb;
    },
    downloadImage(index) {
      window.open(this.getFullImage(this.getSavedImageId(index)), "_blank");
    },
    startImageResize() {
      loaderStart();
    },
    endImageResize() {
      loaderDone();
    }
  }
};
</script>
<style scoped>
.actual-state {
  border: 1px solid lightgray;
}
.actual-state__single-image {
  border: 1px solid lightgray;
  border-radius: 2px;
  height: 90px;
  max-width: 200px;
  margin: 0 auto;
}
.actual-state__icon {
  padding: 1.3rem;
  margin: 0 auto;
}
.actual-state__icon-delete {
  padding: 0;
  margin: 0;
  height: 10px;
  width: 10px;
  right: 4px;
  top: 4px;
  transform: rotate(45deg);
  position: absolute;
}
.actual-state__image {
  max-height: 103px;
  object-fit: contain;
  margin: 0;
  height: 80%;
  padding: 0 4px;
  overflow: hidden;
  width: 100%;
}
.actual-state__image-text {
  background-color: gray;
  color: white;
  font-size: 12px;
  background-clip: content-box;
  max-height: 30px;
}
</style>
